var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.classStyle,attrs:{"type":_vm.inputType,"readonly":"","disabled":_vm.classStyle==='disabled-btn'},domProps:{"value":_vm.text},on:{"click":function($event){return _vm.btnClick($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }